<template>
  <section class="main">
            <div class="content_page_title">
                <h1 id="confirmationMail">Validation du compte en cours.</h1>
            </div>
            <div class="main_content">
                
            </div>
            <div id ="scrollTo"></div>
        </section>
    </template>
    <script>
    import axios from 'axios'

    export default {
      mounted() {
        this.confirmationCompteUtil()
      },
      methods: {
        confirmationCompteUtil(){
          axios.get('/utilisateur/confirmation', {
            params: {
              uuid: this.$route.query.uuid
            }
          }).then(response => {
            if(!response.data.success) {
              this.$notify({
                  group: 'general-notification',
                  type: 'error',
                  text: response.data.message
              });
            } else {
              var confirmMail = document.getElementById("confirmationMail");
              confirmMail.innerHTML = "<p>Votre compte est disponible.</p>";
              this.$notify({
                group: 'general-notification',
                type: 'success',
                text: "Votre compte a été activé"
              });
            }
          }).catch(error => {
            this.$notify({
                group: 'general-notification',
                type: 'error',
                text: error.response.data.message
            })
            console.error('Création utilisateur', error.response)
          });
        }
      }
    }
    </script>
<style>
.errorPassword {
  font-size: 12px;
  color: red;
}

.v-autocomplete-input {
  height: 30px;
  width: -webkit-fill-available;
  border: 1px solid #a8a8a8;
  padding: 6px 11px;
  font-size: 0.9em;
}

.v-autocomplete .v-autocomplete-list {
  position: absolute;
  overflow-y: scroll;
  max-height: 150px;
}
</style>
